export const MessageTypes = {
  SUBMIT: "submit",
  GET_DETAILS: "get_details",
  SUBMIT_PUBLIC: "submit_public",
  GET_CREDS: "get_creds",
  REQUEST_CREDS: "request_creds",
  DELETE_CREDS: "delete_creds",
};
